module.exports = __webpack_public_path__ + "static/img/yingxiao_icon5.1b688a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/yingxiao_icon5.png
// module id = wujV
// module chunks = 0